import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ldn_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        // Small delay to avoid layout shift on first paint
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (_) { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Consentement aux cookies"
      className="fixed inset-x-0 bottom-0 z-[60] md:inset-x-auto md:bottom-6 md:right-6 md:max-w-md"
    >
      <div className="bg-white border-t border-black/15 md:border md:shadow-2xl">
        <div className="p-5 md:p-6">
          <div className="flex items-start gap-3">
            <div className="flex-none w-9 h-9 rounded-full bg-black text-white flex items-center justify-center">
              <Cookie size={16} strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <p className="overline">Confidentialité</p>
              <p className="font-serif-display text-xl mt-1 leading-snug">
                Un mot sur les cookies.
              </p>
              <p className="mt-2 text-sm text-neutral-700 leading-relaxed">
                Ce site utilise uniquement des cookies strictement nécessaires à son
                bon fonctionnement. Aucun cookie de traçage publicitaire n'est déposé.
                {" "}
                <Link
                  to="/confidentialite"
                  data-testid="cookie-banner-policy-link"
                  className="underline hover:opacity-70"
                  onClick={() => setVisible(false)}
                >
                  En savoir plus
                </Link>.
              </p>

              <div className="mt-5 flex flex-col sm:flex-row gap-2">
                <button
                  data-testid="cookie-banner-accept"
                  onClick={() => persist("accepted")}
                  className="flex-1 inline-flex items-center justify-center bg-black text-white py-3 rounded-sm text-sm tracking-wide hover:bg-neutral-800 transition-colors"
                >
                  J'ai compris
                </button>
                <button
                  data-testid="cookie-banner-refuse"
                  onClick={() => persist("refused")}
                  className="flex-1 inline-flex items-center justify-center border border-black py-3 rounded-sm text-sm tracking-wide hover:bg-black hover:text-white transition-colors"
                >
                  Refuser
                </button>
              </div>
            </div>
            <button
              data-testid="cookie-banner-close"
              onClick={() => persist("dismissed")}
              aria-label="Fermer"
              className="flex-none p-1 -m-1 text-neutral-500 hover:text-black transition-colors"
            >
              <X size={18} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
